import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCreativesData, getPublishListData, getPublishTag, postPublish, postPublishesCreatives } from "../../helpers/backend_helper";
import { setCreativesForPublish, setPublishedCreatives, setPublishList, setPublishLoader, setSelectedCreativesPublish, setSelectedPublishType, setWhereToPublish } from "./reducer";
import { push, replace } from "redux-first-history";
import { togglePublishScriptErrModal, togglePublishScriptSuccModal } from "../modals/reducer";
import { toast } from "react-toastify";
import { setCampaignLoader, setCreatives, setCreativesFirstLoad, setCreativesHasMore, setCreativesLoading, setCreativesPage, setScrolledCreatives } from "../campaigns/reducer";
import { openCampaign, updateVersionStatusAfterUpdate } from "../campaigns/thunk";
import { checkMaintenance } from "../auth/login/helper";
import { setBreadcrumb } from "../auth/menu/reducer";

export const getPublishList = createAsyncThunk("publish/getPublishListData", async (params, { dispatch, getState }) => {
  try {
    const { clientPath } = getState().MenuData;
    const { currentCampaign } = getState().Campaign;
    const res = await getPublishListData({ clientId: clientPath, type: currentCampaign.adType });
    if (res.status === "ok") {
      return res.data
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const getScriptPublishTag = createAsyncThunk("publish/getPublishTagData", async (params, { dispatch, getState }) => {
  try {
    const res = await getPublishTag();
    if (res.status === "ok") {
      return res.data;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
})

export const openPublishPage = () => async (dispatch, getState) => {
  try {
    const { client, title } = getState().MenuData;
    const uploadLimits = getState().Upload.uploadLimits;
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesPage,
      currentCampaign,
      currentVersion,
      versions,
      creatives,
      connectedFeed,
      connectedFeedName,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      facebookId,
      dynamicText,
      activeDynamicText,
      filteredFontList,
    } = getState().Campaign;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        id: getState().Campaign.id,
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brandId: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    dispatch(setPublishLoader(true));
    dispatch(setWhereToPublish(true));
    dispatch(setPublishList([]));
    dispatch(setSelectedPublishType(null));
    dispatch(setCreativesForPublish(null));
    dispatch(setSelectedCreativesPublish([]));
    const publishListRes = await dispatch(getPublishList());
    const foundClient = client.clients.find(item => item._id === currentCampaign.clientId);
    const foundClientName = foundClient.clientName.toLowerCase().replaceAll(/\s+/g, "-")
    const foundBrand = foundClient.brands.find(item => item._id === currentCampaign.brandId);
    const foundBrandName = foundBrand.name.toLowerCase().replaceAll(/\s+/g, "-");
    const foundMarket = foundBrand.markets.find(item => item._id === currentCampaign.marketId);
    const foundMarketName = foundMarket.name.toLowerCase().replaceAll(/\s+/g, "-");
    // dispatch(replace(window.location.href, {
    //   campaigns: allLibraries,
    //   hasMore: allLibrariesHasMore,
    //   firstLoad: false,
    //   campaignPage: allLibrariesPage,
    //   isLoading: false,
    //   showLoader: false,
    //   currentCampaign: currentCampaign,
    //   version: versions,
    //   currentVersion: currentVersion,
    //   facebookProperties: facebookProperties,
    //   connectedFeed: connectedFeed,
    //   connectedFeedName: connectedFeedName,
    //   dynamicText: dynamicText,
    //   activeDynamicText: activeDynamicText,
    //   fontRes: filteredFontList,
    //   previewFonts: '',
    //   creatives: creatives.map((item) => {
    //     let returnObj = {};
    //     let keys = Object.keys(item);
    //     keys.forEach(key => {
    //       if (key !== 'preview') {
    //         returnObj[key] = item[key];
    //       }
    //     });
    //     returnObj.isLoading = true;
    //     return returnObj;
    //   }),
    //   uploadLimits: uploadLimits,
    //   title: title
    // }));
    dispatch(setCreativesFirstLoad(true));
    dispatch(setScrolledCreatives([]));
    // setTimeout(() => {
      dispatch(push(`/${foundClientName}/${foundBrandName}/${foundMarketName}/publish/${currentCampaign._id}`, {
        versions: versions,
        currentVersion: (versions[0] ? versions[0] : null),
        currentCampaign: currentCampaign,
        publishList: publishListRes.payload,
        creatives: creatives.map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          returnObj.isLoading = true;
          return returnObj;
        }),
        title: title,
        connectedFeed: connectedFeed,
        connectedFeedName: connectedFeedName,
        whereToPublish: true,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        facebookStatus: facebookStatus,
        facebookCreativeIds: facebookCreativeIds,
      }));
    // }, 1);
  } catch (error) {
    // console.log('error', error);
    checkMaintenance(dispatch, error);
  }
};

export const getCreativesForPublish = createAsyncThunk('publish/getCreativesForPublish', async (version, { dispatch, getState }) => {
  try {
    const { versions } = getState().Campaign;
    const creatives = [];
    if (version?.value === 'all') {
      let i = 0;
      do {
        const res = await getCreativesData({ versionId: versions[i]._id });
        if (res.status === 'ok') {
          creatives.push(...res.data);
        }
        i++;
      } while (i < versions.length);
    } else {
      const res = await getCreativesData({ versionId: version?.value });
      if (res.status === 'ok') {
        creatives.push(...res.data);
      }
    }
    return creatives;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const publishCreatives = (type) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { client } = getState().MenuData;
    const { currentCampaign } = getState().Campaign;
    const { selectedCreativesPublish, selectedPublishType, selectedPublishTagId, creativesForPublish } = getState().Publish;
    let templateType = selectedCreativesPublish[0].hasOwnProperty('figma') ? 'figma' : '';
    const creativeIds = selectedCreativesPublish.map(item => item._id);
    dispatch(setPublishLoader(true));
    const res = await postPublish({
      companyId: client._id,
      creativeIds: creativeIds,
      campaignId: currentCampaign._id,
      publishType: type,
      publishTagId: selectedPublishTagId,
      templateType: templateType
    });
    dispatch(setPublishLoader(false));
    if (res.status === 'ok') {
      dispatch(setPublishedCreatives(res.data));
      dispatch(updateCreativePublishStatusAfterPublish(creativeIds));
      dispatch(togglePublishScriptSuccModal());
    } else {
      dispatch(setCreativesForPublish(null));
      setTimeout(() => {
        dispatch(setCreativesForPublish(creativesForPublish));
      }, 1);
      dispatch(setSelectedCreativesPublish([]));
      throw res;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const pushChanges = () => async (dispatch, getState) => {
  const { language, client, title } = getState().MenuData;
  try {
    const {
      currentCampaign,
      creatives,
      facebookProperties,
      connectedFeed,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      uploadLimits
    } = getState().Campaign;
    if (creatives.length > 0) {
      const creativeIds = creatives.filter(item => item.published === true).map(item => item._id);
      const res = await postPublishesCreatives({ creativeIds: creativeIds });
      let error = null;
      if (res.status === 'ok') {
        const dcmPublish = [];
        const adformPublish = [];
        const scriptPublish = [];
        let scriptRes;
        let i = 0;
        do {
          const creativeObj = res.data[i];
          if (creativeObj.publishType === 'scriptTags') {
            scriptPublish.push(creativeObj.placementId);
          }
          if (creativeObj.dcm === true) {
            dcmPublish.push(creativeObj.placementId);
          }
          if (creativeObj.adform === true) {
            adformPublish.push(creativeObj.placementId);
          }
          i++;
        } while (i < res.data.length);
        dispatch(setCampaignLoader(true));
        if (scriptPublish.length > 0) {
          scriptRes = await postPublish({
            companyId: client._id,
            creativeIds: scriptPublish,
            campaignId: currentCampaign._id,
            publishType: 'scriptTags',
            templateType: 'figma'
          });
          if (scriptRes.status !== 'ok') {
            error = language[scriptRes?.code];
          }
        }
        if (dcmPublish.length > 0) {
          const dcmRes = await postPublish({
            companyId: client._id,
            creativeIds: dcmPublish,
            campaignId: currentCampaign._id,
            publishType: 'dcm',
            templateType: 'figma'
          });
          if (dcmRes.status === 'err') {
            error = language[dcmRes?.code];
          }
        }
        if (adformPublish.length > 0) {
          const adformRes = await postPublish({
            companyId: client._id,
            creativeIds: adformPublish,
            campaignId: currentCampaign._id,
            publishType: 'adform',
            templateType: 'figma'
          });
          if (adformRes.status === 'err') {
            error = language[adformRes?.code];
          }
        }
        if (error) {
          throw error;
        }
        const updateRes = await dispatch(updateVersionStatusAfterUpdate());
        dispatch(setCampaignLoader(false));
        dispatch(setBreadcrumb({ pageTitle: 'Ad Library', title: [] }));
        await dispatch(openCampaign(currentCampaign, { ...updateRes.updatedVersion, published: 2 }))
        if (scriptRes.status === 'ok') {
          dispatch(setPublishedCreatives(scriptRes.data.map((item, idx) => { return { ...item, creativeId: scriptPublish[idx] } })));
          dispatch(togglePublishScriptSuccModal());
        }
        toast.success('Publish Success', { autoClose: 3000 });
      } else {
        throw language[res.code];
      }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    dispatch(setCampaignLoader(false));
    toast.error(error, { autoClose: 3000 });
  }
}

export const updateCreativePublishStatusAfterPublish = (creativeIds) => async (dispatch, getState) => {
  try {
    const { creativesForPublish } = getState().Publish
    if (creativesForPublish.length > 0 && creativeIds.length > 0) {
      const updatedCreatives = [];
      let i = 0;
      do {
        const creative = creativesForPublish[i];
        const foundCreativeId = creativeIds.find(id => id === creative._id);
        if (foundCreativeId) {
          updatedCreatives.push({ ...creative, published: true })
        } else {
          updatedCreatives.push(creative);
        }
        i++;
      } while (i < creativesForPublish.length);
      dispatch(setCreativesForPublish(updatedCreatives));
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}